<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.17334 14.9567L15.0175 1.11237" stroke="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M14 3.89775L11.8978 6H14V3.89775ZM8.36226 6H2V2H12.3622L11.0289 3.33333H3.33333V4.66667H9.69558L8.36226 6ZM4 10.3623L2.66667 11.6957V6.66667H4V10.3623ZM3.89787 14L5.23118 12.6667H12V6.66667H13.3333V14H3.89787Z" fill="currentColor"/>
</svg>
